module.exports = __webpack_public_path__ + "static/img/gp.ffe3f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info/gp.png
// module id = 9AYW
// module chunks = 1